import { inject, Injectable } from '@angular/core';
import { KlaviyoEventLoginTrigger } from '@df/klaviyo/event/login/klaviyo-event-login.trigger';
import { LocalPwaIntegrationService } from '../pwa/pwa-integration.service.decorator';

/**
 * Local Klaviyo login event trigger
 * Extends the base trigger to add browsingType parameter based on PWA standalone mode
 */
@Injectable({
    providedIn: 'root'
})
export class LocalKlaviyoEventLoginTrigger extends KlaviyoEventLoginTrigger {
    /**
     * Local PWA integration service
     */
    private localPwaIntegrationService = inject(LocalPwaIntegrationService);

    /**
     * Override trackData to add browsingType parameter
     */
    protected override trackData() {
        const baseData = super.trackData();
        
        return {
            ...baseData,
            browsingType: this.localPwaIntegrationService.isStandalone ? 'app' : 'web'
        };
    }
}
